import { IdentifierStatus } from '../enums/identifier-status.enum';

export const CORPORATE_EMAIL_STATUS_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.corporate.email.status.v1+json';

export class CorporateEmailStatus {
  public email: string;
  public status: IdentifierStatus;

  public toBackEndPatch(): BackEndCorporateEmailStatus {
    return {
      email: this.email,
      status: this.status
    };
  }
}

export interface BackEndCorporateEmailStatus {
  email: string;
  status: IdentifierStatus;
}
